import React from 'react'
import companyLocation from "../../images/company_locations.svg"
import { isEmpty } from 'lodash';

function LocationDetail(props) {

  const location = props.data;

  return (

    <div className='company-address-wrape'>
      <h3>
        {/* <img src={companyLocation} alt="" className='company-info-icon mx-1' /> */}
        {props.title}
      </h3>
      <div className='address-pad'>
        <p>
          <span>Address </span>
          {(!isEmpty(location) && !isEmpty(location.address1)) ? location.address1 : ''}{!isEmpty(location) && !isEmpty(location.address2) ? ',' : ''} {!isEmpty(location) && !isEmpty(location.address2) ? location.address2 : ''}{!isEmpty(location) && isEmpty(location.address1) && isEmpty(location.address2) ? '-' : '' }
        </p>

        <p>
          <span>Country </span>
          {!isEmpty(location) && !isEmpty(location.country) ? location.country.name : '-'}
        </p>

        <p>
          <span>City </span>
          {!isEmpty(location) && !isEmpty(location.city) ? location.city.name : '-'}
        </p>

        <p>
          <span>Postal code </span>
          {!isEmpty(location) && !isEmpty(location.pincode) ? location.pincode : '-'}
        </p>
      </div>

    </div>

  )
}

export default LocationDetail;